<div class="seat-panel-component" [class.from-abono-styles]="fromAbono" [class.seats-totem]="totemActive"
    [class.season-pass-styles]="seasonPassMode">
    <div class="content-map-select">
        <div *ngIf="!loaded" class="container-lottie">
            <div class="loading-container">
                <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                    containerClass="loading-box"></ng-lottie>
            </div>
        </div>
        <div class="w-100 close-small" [class.close-from-abono]="fromAbono || totemActive || seasonPassMode"
            [class.title-seats-totem]="totemActive" [class.item-small]="!fromAbono && !seasonPassMode">
            <div *ngIf="totemActive">
                <p class="m-0">Seleccionar {{ fromAbono || seasonPassMode ? 'asientos' : selectionNoun + 's' }}</p>
            </div>
            <i class="btn-close-map fa-times" [class]="totemActive?'fa-light':'fa-regular'" mat-dialog-close></i>
        </div>
        <!-- Progreso de selección de asientos en modo abono -->
        <div class="abono-top-progress" *ngIf="fromAbono && abonoQuantity > 1">
            <div class="abono-top-header">
                <span class="abono-top-label">Asientos seleccionados</span>
                <span class="abono-top-count">{{ selectedSeats.length }}/{{ abonoQuantity }}</span>
            </div>
            <div class="abono-top-bar">
                <div class="abono-top-bar-fill"
                     [style.width.%]="(selectedSeats.length / abonoQuantity) * 100">
                </div>
            </div>
        </div>
        <!-- Abono de butaca única: lo que se elige aquí vale para todos sus eventos -->
        <div class="single-seat-notice" *ngIf="singleSeatPass">
            <i class="fa-light fa-chair"></i>
            <span>{{ abonoQuantity > 1 ? 'Las butacas que elijas serán las mismas' : 'La butaca que elijas será la misma' }} en todos los eventos del abono.</span>
        </div>

        <!-- Selector de áreas + botón volver inline (mapa completo o sin navegación por zonas) -->
        <div class="map-controls-bar">
            <button *ngIf="zoneNavigation && showingFullMap" (click)="backToOverview()" class="btn-zone-nav">
                <i class="fa-light fa-arrow-left"></i> Volver al plano general
            </button>
            <div class="info-areas" *ngIf="levelsEnabled.length>0 && (!zoneNavigation || showingFullMap)">
                <div>
                    <mat-form-field appearance="fill" class="w-100 filter-areas-seats">
                        <mat-select-trigger matPrefix style="vertical-align: middle;" class="prefix-areas" *ngIf="levelSelected">
                            <div class="color-area" [style.background-color]="levelSelected?.color"></div>
                        </mat-select-trigger>
                        <mat-select panelClass="selectAreas" placeholder="Selecciona un área"
                            [value]="levelSelected" (selectionChange)="selectArea($event.value)">
                            <mat-option class="area-item option-area" *ngFor="let level of levelsEnabled" [value]="level">
                                <div class="color-area" [style.background-color]="level.color"></div>
                                <p class="m-0">{{level.name}}</p>
                            </mat-option>
                        </mat-select>
                        <mat-select-trigger matSuffix style="vertical-align: middle;">
                            <i class="fal fa-angle-down pointer-in"></i>
                        </mat-select-trigger>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!-- Barra de navegación por zonas (overview y vista de zona) -->
        <div class="zone-nav-bar" *ngIf="zoneNavigation && !showingFullMap">
            <button *ngIf="!inOverview" (click)="backToOverview()" class="btn-zone-nav">
                <i class="fa-light fa-arrow-left"></i> Volver al plano general
            </button>
            <button (click)="showFullMap()" class="btn-zone-nav">
                <i class="fa-light fa-expand"></i> Ver mapa completo
            </button>
            <p *ngIf="inOverview" class="m-0 zone-nav-hint">
                Selecciona una zona para ampliarla y elegir tus {{ fromAbono || seasonPassMode ? 'asientos' : selectionNoun + 's' }}.
            </p>
        </div>
        <div class="select-hidden-code" *ngIf="(profile?.protocolo)">
            <!-- <p class="m-0 info-hidden-code"><i
                class="fa-light fa-circle-exclamation icon-primary icon-save"></i>¿Quieres
            comprar asientos reservados? Introduce tu código </p> -->

            <p class="m-0 info-hidden-code"><i
                    class="fa-light fa-circle-exclamation icon-primary icon-save"></i>¿Quieres
                comprar asientos reservados? Introduce tu código <span (click)="openFormCode()"
                    class="link-open pointer-in">aquí.</span></p>
            <div class="hidden-code container-form d-flex align-items-center" [class.savedCode]="savedCode"
                *ngIf="openFormDiscount">
                <input class="w-100" type="text" placeholder="Código de desbloqueo" [(ngModel)]="hiddenCode"
                    [readonly]="savedCode">
                <button class="btn-discount cancel-button" [class.active]="hiddenCode" *ngIf="!savedCode"
                    (click)="applyCode()">Aplicar</button>
                <button *ngIf="savedCode" class="btn-discount cancel-button" [class.active]="hiddenCode"
                    (click)="deleteCode()"><i class="fa-light fa-trash-can icon-primary icon-save"></i>Eliminar</button>
            </div>
            <p *ngIf="savedCode" class="info-correct"><i class="fa-light fa-circle-check icon-primary icon-save"></i>Se
                han desbloqueado los asientos correspondientes: {{discountObject.hiddenSeat.name}}</p>
            <p *ngIf="errorCode && openFormDiscount" class="error-discount"><i
                    class="fa-light fa-circle-xmark icon-red icon-error"></i>
                El descuento no existe o no se ha podido aplicar.</p>
        </div>
        <div class="buttons-zoom-map" [class.buttons-zoom-totem]="totemActive">
            <button (click)="zoomMap(true, $event)">
                <i class="fa-regular fa-plus" [class.fa-lg]="totemActive"></i>
            </button>
            <button (click)="zoomMap(false, $event)">
                <i class="fa-regular fa-minus" [class.fa-lg]="totemActive"></i>
            </button>
        </div>
        <div id="canvas-container" class="canvas-container">
            <canvas id="myCanvas"></canvas>
            <div class="legend-icon" [class.activeLegend]="openLegend" [class.legend-totem]="totemActive" (click)="openedLegend()">
                <i class="fa-light fa-circle-info icon-primary icon-save"></i>
            </div>
            <div class="legend-map" [class.activeLegend]="openLegend" [class.legend-map-totem]="totemActive" (click)="openedLegend()">
                <div class="d-flex align-items-center justify-content-between item-legend" *ngFor="let entry of legendEntries">
                    <p class="name-legend">{{ entry.label }}: </p>
                    <div class="color-legend" [style.background]="entry.color"></div>
                </div>
            </div>
            <app-seat-map-minimap
                *ngIf="!inOverview && zoneNavigation && !showingFullMap"
                [navPreview]="navPreview"
                [selectedZone]="selectedZone"
                (zoneSelected)="onMinimapZoneSelected($event)">
            </app-seat-map-minimap>
        </div>
<div class="actived-seat w-100" *ngIf="activedSeat && optionSection">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <p class="name-section m-0">{{levelSelected?.name}}</p>
                <i class="btn-close-map fa-regular fa-times pointer-in" (click)="closeActived()"></i>
            </div>
            <div class="already-selected-hint" *ngIf="!fromAbono && selectedSeats.length > 0">
                <i class="fa-light fa-bag-shopping icon-primary"></i>
                Ya tienes <strong>{{selectedSeats.length}} {{selectedNoun}}{{selectedSeats.length > 1 ? 's' : ''}}</strong> en tu selección.
            </div>
            <div class="options-price">
                <div class="d-flex" *ngIf="checkInvite">
                    <i class="fa-light fa-circle-check icon-invite"></i>
                    <p class="m-0 info-invite">Todas las entradas cuentan con un descuento del 100%.</p>
                </div>
                <div class="d-flex" style="gap: 8px;" *ngIf="fromAbono">
                    <i class="fa-light fa-circle-info icon-primary"></i>
                    <p class="m-0">Recuerda que la reserva del asiento se realizará al añadirlo al carrito.</p>
                </div>
                <div *ngIf="!optionSection || optionSection.length <= 0">
                    <p>Cargando...</p>
                </div>
                <div class="d-flex align-items-center justify-content-between type-ticket"
                    *ngFor="let option of optionSection; let i = index">
                    <div class="d-grid">
                        <span>{{option.name}}</span>
                        <span>{{option.price | number:'1.2-2'}} €</span>
                        <span class="description-ticket"
                            *ngIf="option.description">*{{option.description}}</span>
                    </div>
                    <button class="w-100 primary-button solid btn-select-ticket" (click)="addTicket(option)">
                        Seleccionar
                    </button>
                </div>
            </div>
        </div>
        <!-- Resumen de asientos seleccionados en modo abono (siempre visible) -->
        <div class="abono-selection-summary" *ngIf="fromAbono && abonoQuantity > 1">
            <div class="abono-summary-header">
                <span class="abono-summary-hint" *ngIf="selectedSeats.length < abonoQuantity">
                    <i class="fa-light fa-chair"></i>
                    Selecciona {{ abonoQuantity - selectedSeats.length }} asiento{{ (abonoQuantity - selectedSeats.length) !== 1 ? 's' : '' }} más
                </span>
                <span class="abono-seats-done" *ngIf="selectedSeats.length >= abonoQuantity">
                    <i class="fa-light fa-circle-check"></i> {{ abonoQuantity }} asientos listos
                </span>
            </div>
            <div class="abono-seats-list" *ngIf="selectedSeats.length > 0">
                <div class="abono-seat-item" *ngFor="let seat of selectedSeats; let i = index">
                    <div class="abono-seat-num">{{ i + 1 }}</div>
                    <div class="abono-seat-info">
                        <span class="abono-seat-section" *ngIf="seat.section?.name">{{ seat.section.name }}</span>
                        <span *ngIf="seat.row != null && !seat.hidden && seat.showRow !== false">Fila {{ seat.row }}</span>
                        <span *ngIf="seat.seat != null">{{ seat.showSeatLabel === false ? ' ' : ' · Butaca ' }}{{ seat.seat }}</span>
                    </div>
                    <button class="abono-seat-remove" (click)="deleteTicket(seat, i)">
                        <i class="fa-light fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Selección de butaca para abono deportivo: una sola butaca, sin tickets -->
        <div class="abono-selection-summary" *ngIf="seasonPassMode">
            <!-- Bloqueos del recinto: en el panel de control el operador puede
                 liberarlos para dar de alta o renovar un abono encima de ellos. -->
            <div class="blocked-toggle" *ngIf="allowBlockedSelection && blockedSeatIds.length > 0">
                <mat-slide-toggle class="toggle-pink" [checked]="blockedUnlocked"
                    (change)="toggleBlockedSelection($event.checked)">
                    Permitir butacas bloqueadas
                </mat-slide-toggle>
                <span class="blocked-toggle-hint">
                    {{ blockedUnlocked
                        ? 'Los bloqueos del recinto se pueden elegir; las butacas de otros abonados, no.'
                        : blockedSeatIds.length + ' butacas bloqueadas por el recinto' }}
                </span>
            </div>
            <div class="blocked-seat-warning" *ngIf="activedBlockedGroup">
                <i class="fa-light fa-triangle-exclamation"></i>
                <span>
                    Esta butaca está bloqueada como
                    <strong>{{ activedBlockedGroup.name }}</strong>. Se asignará al abono igualmente.
                </span>
            </div>
            <div class="abono-summary-header">
                <!-- Sin butaca activa (p. ej. abono sin asignar) -->
                <span class="abono-summary-hint" *ngIf="!activedSeat">
                    <i class="fa-light fa-chair"></i>
                    Toca una butaca libre en el plano para elegirla
                </span>
                <!-- Butaca ya asignada (sin cambio): marca actual en rosa -->
                <span class="abono-seats-current" *ngIf="activedSeat && !isNewSeatSelected">
                    <span class="abono-seat-tag">Butaca actual</span>
                    <span class="abono-seat-detail">
                        <ng-container *ngIf="levelSelected?.name">{{ levelSelected.name }}</ng-container>
                        <ng-container *ngIf="activedSeat.row != null"> · Fila {{ activedSeat.row }}</ng-container>
                        <ng-container *ngIf="activedSeat.seat != null"> · Butaca {{ activedSeat.seat }}</ng-container>
                    </span>
                </span>
                <!-- Butaca nueva seleccionada en el plano -->
                <span class="abono-seats-new" *ngIf="isNewSeatSelected">
                    <span class="abono-seat-tag"><i class="fa-light fa-circle-check"></i> Butaca seleccionada</span>
                    <span class="abono-seat-detail">
                        <ng-container *ngIf="levelSelected?.name">{{ levelSelected.name }}</ng-container>
                        <ng-container *ngIf="activedSeat.row != null"> · Fila {{ activedSeat.row }}</ng-container>
                        <ng-container *ngIf="activedSeat.seat != null"> · Butaca {{ activedSeat.seat }}</ng-container>
                    </span>
                </span>
            </div>
            <button class="w-100 primary-button solid btn-finish" (click)="confirmSeasonPassSeat()"
                [class.disabled]="!activedSeat">
                {{ isNewSeatSelected ? 'Elegir esta butaca' : 'Mantener butaca' }}
            </button>
        </div>
    </div>
    <div class="info-select-map" [class.openedActived]="activedSeat" *ngIf="!fromAbono && !seasonPassMode">
        <div class="w-100 justify-content-end close-big" *ngIf="!totemActive">
            <i class="btn-close-map fa-regular fa-times" mat-dialog-close></i>
        </div>
        <p class="title-selected-ticket">Entradas seleccionadas</p>
        <div class="tickets-scroll-area" *ngIf="(selectedSeats.length === 0 && loaded) || (openDetail && selectedSeats.length > 0)">
            <div class="selection-hint-banner" *ngIf="selectedSeats.length === 0 && loaded">
                <i class="fa-light fa-hand-pointer"></i>
                <p class="m-0">Toca una {{selectionNoun}} disponible en el plano para seleccionarla. Puedes elegir varias antes de ir al carrito.</p>
            </div>
            <div class="list-selected" *ngIf="openDetail">
                <div class="ticket-card" *ngFor="let item of selectedSeats; let i = index">
                    <div class="ticket-card-index">{{i + 1}}</div>
                    <div class="ticket-card-body">
                        <span class="ticket-card-name">{{item.option.name}} - {{ item.levelName }}</span>
                        <div class="ticket-card-location">
                            <span *ngIf="item.section?.name">{{ item.section.name }}</span>
                            <span *ngIf="item.row != null && !item.hidden && item.showRow !== false">Fila: {{item.row}}</span>
                            <span *ngIf="item.seat != null"><ng-container *ngIf="item.showSeatLabel !== false">Asiento: </ng-container>{{item.seat}}</span>
                        </div>
                    </div>
                    <div class="ticket-card-right">
                        <span class="ticket-card-price">{{invite ? 0 : item.option.price | number:'1.2-2'}} €</span>
                        <button class="ticket-card-delete" (click)="deleteTicket(item, i)" title="Eliminar">
                            <i class="fa-light fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="resume-buy">
            <div class="align-items-center pointer-in item-small" *ngIf="selectedSeats.length > 0" (click)="openDetail=!openDetail" style="gap: 10px;">
                <i class="fa-light icon-primary" [class]="openDetail ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                <p class="m-0">{{openDetail ? 'Ocultar' : 'Mostrar'}} entradas</p>
            </div>
            <div class="seat-added-toast" *ngIf="addedSeatToast" [class.fading]="toastFading">
                <i class="fa-light fa-circle-check"></i> {{ addedSeatToast }}
            </div>
            <button class="w-100 primary-button solid btn-finish" (click)="goBuyTickets()"
                [class.disabled]="selectedSeats.length <= 0">
                <ng-container *ngIf="fromAbono">Confirmar</ng-container>
                <ng-container *ngIf="!fromAbono && selectedSeats.length === 0">Selecciona una {{selectionNoun}}</ng-container>
                <ng-container *ngIf="!fromAbono && selectedSeats.length > 0">
                    Añadir {{selectedSeats.length}} {{selectedSeats.length === 1 ? 'entrada' : 'entradas'}}
                    <span class="info-ticket-btn-sep">·</span>
                    {{invite ? 0 : totalPrice | number:'1.2-2'}} €
                </ng-container>
            </button>
            <p class="info-discount" *ngIf="!fromAbono"><i class="fa-light fa-circle-info icon-primary icon-save"></i>
                ¿Tienes un código de descuento? Introdúcelo en la siguiente pantalla.</p>
        </div>
    </div>
</div>